//#region src/js/quantity.js
var QuantityInput = class extends HTMLElement {
	connectedCallback() {
		if (this.initialized) return;
		this.initialized = true;
		this.input = this.querySelector("input");
		this.span = this.querySelector("[data-quantity]");
		this.changeEvent = new Event("change", { bubbles: true });
		this.querySelectorAll("button").forEach((button) => button.addEventListener("click", this.onButtonClick.bind(this)));
		this.input.addEventListener("change", () => {});
		this.span.textContent = this.input.value;
	}
	onButtonClick(event) {
		event.preventDefault();
		const previousValue = this.input.value;
		event.currentTarget.name === "plus" ? this.input.stepUp() : this.input.stepDown();
		if (previousValue !== this.input.value) {
			this.input.dispatchEvent(this.changeEvent);
			this.span.textContent = this.input.value;
		}
	}
};
customElements.define("quantity-input", QuantityInput);
//#endregion
